import { createContext } from 'react';
import { getTestIds } from '../utils/TestIds';
export const OverlayLoaderTID = 'async-backdrop';
export const { OverlayToastsTestIds } = getTestIds();
const noop = ()=>{};
export const OverlayContext = createContext({
    isTestMode: false,
    getHasOpenBottomSheet: ()=>false,
    claimZIndexOrder: ()=>0,
    releaseZIndexOrder: noop,
    getOpenedModals: ()=>[],
    showModal: async ()=>undefined,
    showConfirmAction: async ()=>Promise.resolve(),
    hideModal: noop,
    hideAllModals: noop,
    startLoader: noop,
    stopLoader: noop,
    showErrorToast: noop,
    showSuccessToast: noop,
    showWarningToast: noop,
    showInfoToast: noop,
    showPersistentToast: ()=>noop,
    showToast: ()=>noop,
    showBottomSheet: noop,
    pushBottomSheetPage: noop,
    popBottomSheetPage: noop,
    removeBottomSheetPage: noop,
    hideBottomSheet: noop
});
